'use client';

import Link from 'next/link';
import classNames from 'classnames';

import { defaultProcessTextWithoutLinks } from 'app/utility/textProcessing';
import IconShareLink from 'app/components/sprites/IconShareLink';
import useCopyToClipboardButton from 'app/hooks/useCopyToClipboardButton';
import { CopyToClipboardNotification } from 'app/components/common/CopyToClipboardNotification';
import { IMassMediaPost } from 'app/interfaces/posts';

export interface IMediaCardProps {
  post: IMassMediaPost;
  className?: string;
}

export default function MediaCard({ post, className }: IMediaCardProps) {
  const { title, source, url } = post;
  const { isOpen, setIsOpen, onCopyToClipboardButtonClick } =
    useCopyToClipboardButton();

  return (
    <>
      <div
        className={classNames(
          'flex flex-col gap-5 md:gap-7 items-start',
          className
        )}
      >
        <Link
          className="grow flex flex-col gap-10 md:gap-7 items-start"
          href={url}
        >
          <h3 className="text-p3">{source}</h3>
          <div
            className="grow md:w-70 max-w-[520px] md:max-w-none pr-20 md:pr-0 text-p2"
            dangerouslySetInnerHTML={{
              __html: defaultProcessTextWithoutLinks(title)
            }}
          />
        </Link>

        <button
          className="group relative z-10 p-2 bg-graphite-dark hover:bg-brown rounded transition-colors duration-300"
          type="button"
          data-href={url}
          onClick={onCopyToClipboardButtonClick}
        >
          <IconShareLink className="w-3.5 h-3 fill-none stroke-brown group-hover:stroke-graphite-dark transition-colors duration-300" />
        </button>
      </div>
      <CopyToClipboardNotification
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
